customElements.whenDefined('foxy-customer-portal').then(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const redirect = urlParams.get('redirect_url');
    if(!redirect) return;

    const portals = [...document.getElementsByTagName('foxy-customer-portal')];
    portals.forEach(portal => {
        portal.addEventListener('signin', function () {
            window.location.href = redirect;
        });
    });
});